export default "../../src/img/vapes-logo-2017-black.svg";